/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  DeleteApiClientsIdMutationResponse,
  DeleteApiClientsIdPathParams,
} from '../models/DeleteApiClientsId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { deleteApiClientsIdMutationResponseSchema } from '../zod/deleteApiClientsIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const deleteApiClientsIdMutationKey = () =>
  [{ url: '/api/clients/:id' }] as const;

export type DeleteApiClientsIdMutationKey = ReturnType<
  typeof deleteApiClientsIdMutationKey
>;

/**
 * {@link /api/clients/:id}
 */
export async function deleteApiClientsId(
  id: DeleteApiClientsIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiClientsIdMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: `/api/clients/${id}`,
    ...requestConfig,
  });
  return deleteApiClientsIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/clients/:id}
 */
export function useDeleteApiClientsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiClientsIdMutationResponse,
      ResponseErrorConfig<Error>,
      { id: DeleteApiClientsIdPathParams['id'] },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiClientsIdMutationKey();

  return useMutation<
    DeleteApiClientsIdMutationResponse,
    ResponseErrorConfig<Error>,
    { id: DeleteApiClientsIdPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return deleteApiClientsId(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
